import * as types from './globalMutations-types'

const mutations = {
  [types.ALERT_STATUS](state, payload) {
    state.alert.status = payload.status
    state.alert.message = payload.message
    state.alert.type = payload.type
    state.alert.keepAlive = payload.keepAlive
  },

  [types.LOADER_STATUS](state, payload) {
    state.loader.showing = payload.showing
  },

  [types.LANGUAGE](state, payload) {
    state.language = payload.language
  },

  [types.DISPLAY_DELETE_MODAL](state, payload) {
    state.displayDeleteModal = payload.displayDeleteModal
  },

  [types.SET_ORGANIZATION_CURRENCY](state, payload) {
    state.currency = payload.currency
  },

  [types.SET_ORGANIZATION_THEME](state, payload) {
    state.theme = payload.theme
  },

  [types.ENABLE_ANONYMOUS_TRACKING](state, payload) {
    state.enableAnonymousTracking = Boolean(payload)
  },

  setImplementError(state, payload) {
    state.implementError = Boolean(payload)
  },
}

export default mutations
